namespace Vit.Administration {
    export interface UserTenantRoleListRequest extends Serenity.ServiceRequest {
        UserID?: number;
    }
}